import { styled } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import AddBoxIcon from "@mui/icons-material/AddBox";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import LogoutIcon from "@mui/icons-material/Logout";
import { route } from "preact-router";
import ProfileIcon from "../../assets/defaultImg.jpg";
import QueueMusicIcon from "@mui/icons-material/QueueMusic";
import { useEffect, useState } from "preact/hooks";
import Logo from "../../assets/logo.png";
import useApi from "../../hooks/useApi";
import { logoutApi } from "../../api/controller/accounts";
import {
  clearSessionStorage,
  getSessionStorage,
  removeCookie,
} from "../../utils";

const NavbarContainer = styled("div")`
  width: 180px;
  background-color: #1c1c1e;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 25px 0;
  font-weight: 600;
  @media only screen and (max-width: 724px) {
    display: none;
  }
  .topNavbarContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .logo {
    width: 160px;
    height: auto;
  }
  .userRoutes {
    text-align: center;
    margin-top: 2.778vh;
  }
  .userStateRoutes {
  }
  .navbarContainer {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 2.778vh;
  }
  .navbarIcon {
    height: 21px;
    width: 21px;
    color: #c4c4c4;
  }
  .navbarRoute {
    color: #c4c4c4;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-left: 10px;
  }
  .activeNavbarIcon {
    height: 21px;
    width: 21px;
    color: #fff;
  }
  .activeNavbarRoute {
    margin-left: 10px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`;

function Navbar() {
  const [active, setActive] = useState(window.location.pathname);
  const logoutRequest = useApi();

  useEffect(() => {
    if (
      logoutRequest.data &&
      logoutRequest.data.data &&
      logoutRequest.data.data.logout
    ) {
      route("/");
      removeCookie("user_key", window.location.host, "/");
      removeCookie("token", window.location.host, "/");
      removeCookie("user_id", window.location.host, "/");
      clearSessionStorage();
    }
  }, [logoutRequest.data]);

  const handleRoute = (routeparam) => {
    setActive(routeparam);
    route(routeparam);
  };

  const userLogout = () => {
    logoutApi(logoutRequest.request, {
      host: getSessionStorage("host"),
    });
  };

  return (
    <NavbarContainer>
      <div className="topNavbarContainer">
        <img src={Logo} alt="Dhun Jam" className="logo" />
        <div className="userRoutes">
          <div
            className="navbarContainer"
            onClick={() => {
              handleRoute("/home/");
            }}
          >
            <HomeIcon
              className={
                active !== "/home/" ? "navbarIcon" : "activeNavbarIcon"
              }
            />
            <div
              className={
                active !== "/home/" ? "navbarRoute" : "activeNavbarRoute"
              }
            >
              Home
            </div>
          </div>
          <div
            className="navbarContainer"
            onClick={() => {
              handleRoute("/slots/");
            }}
          >
            <LibraryMusicIcon
              className={
                active !== "/slots/" ? "navbarIcon" : "activeNavbarIcon"
              }
            />
            <div
              className={
                active !== "/slots/" ? "navbarRoute" : "activeNavbarRoute"
              }
            >
              Slots
            </div>
          </div>
          {/* <div
            className="navbarContainer"
            onClick={() => {
              handleRoute("/requests/");
            }}
          >
            <AddBoxIcon
              className={
                active !== "/requests/" ? "navbarIcon" : "activeNavbarIcon"
              }
            />
            <div
              className={
                active !== "/requests/" ? "navbarRoute" : "activeNavbarRoute"
              }
            >
              Requests
            </div>
          </div> */}
          <div
            className="navbarContainer"
            onClick={() => {
              handleRoute("/played-songs/");
            }}
          >
            <LibraryAddCheckIcon
              className={
                active !== "/played-songs/" ? "navbarIcon" : "activeNavbarIcon"
              }
            />
            <div
              className={
                active !== "/played-songs/"
                  ? "navbarRoute"
                  : "activeNavbarRoute"
              }
            >
              Played
            </div>
          </div>
          <div
            className="navbarContainer"
            onClick={() => {
              handleRoute("/songs-list/");
            }}
          >
            <QueueMusicIcon
              className={
                active !== "/songs-list/" ? "navbarIcon" : "activeNavbarIcon"
              }
            />
            <div
              className={
                active !== "/songs-list/" ? "navbarRoute" : "activeNavbarRoute"
              }
            >
              Songs List
            </div>
          </div>
          {/* <div className='navbarContainer' onClick={() => { handleRoute('/analytics/') }}>
            <EqualizerIcon className={active !== '/analytics/' ? 'navbarIcon' : 'activeNavbarIcon'} />
            <div className={active !== '/analytics/' ? 'navbarRoute' : 'activeNavbarRoute'}>Analytics</div>
          </div> */}
        </div>
      </div>
      <div className="userStateRoutes">
        <div
          className="navbarContainer"
          onClick={() => {
            handleRoute("/profile/");
          }}
        >
          <img
            style={{
              borderRadius: "999px",
            }}
            src={
              getSessionStorage("insta_pic")?.length > 0 &&
              getSessionStorage("insta_pic") != "null"
                ? getSessionStorage("insta_pic")
                : ProfileIcon
            }
            className={
              active !== "/profile/" ? "navbarIcon" : "activeNavbarIcon"
            }
          />
          <div
            className={
              active !== "/profile/" ? "navbarRoute" : "activeNavbarRoute"
            }
          >
            Profile
          </div>
        </div>
        <div
          className="navbarContainer"
          onClick={() => {
            userLogout();
          }}
        >
          <LogoutIcon className="navbarIcon" />
          <div className="navbarRoute">Logout</div>
        </div>
      </div>
    </NavbarContainer>
  );
}

export default Navbar;
